"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
var PlanName;
(function (PlanName) {
    PlanName["trial"] = "trial";
    PlanName["starter"] = "starter";
    PlanName["advanced"] = "advanced";
    PlanName["professional"] = "professional";
    PlanName["premium"] = "premium";
    PlanName["freeze"] = "freeze";
})(PlanName = exports.PlanName || (exports.PlanName = {}));
exports.planAccess = {
    freeze: [PlanName.freeze],
    starter: [PlanName.starter],
    advanced: [PlanName.advanced, PlanName.starter],
    professional: [PlanName.professional, PlanName.advanced, PlanName.starter],
    premium: [PlanName.premium, PlanName.professional, PlanName.advanced, PlanName.starter],
    trial: [PlanName.premium, PlanName.professional, PlanName.advanced, PlanName.starter]
};
exports.monthlyPlans = [
    {
        name: 'Starter',
        stripeId: 'plan_G8EHOsVnkW4Z3e',
        custom: false,
        limit: 10,
        free: true,
        quantity: 10,
        title: 'Free, max 10 games per month',
        description: 'Include LIGR and third party advertisements.',
        brackets: [{ upTo: 10, price: 0 }]
    },
    {
        name: 'Advanced',
        stripeId: 'plan_G8EFLP5GmO5OQP',
        custom: false,
        limit: undefined,
        quantity: 4,
        title: 'From $30, includes 4 games per month',
        description: 'Competition, Team and Player asset management. No ads.',
        brackets: [
            { upTo: 4, price: 30 },
            { upTo: 10, price: 70 },
            { upTo: 20, price: 130 },
            { upTo: 50, price: 300 },
            { upTo: 100, price: 500 }
        ]
    },
    {
        name: 'Professional',
        stripeId: 'plan_G8EJYobi6t7oRB',
        custom: false,
        limit: undefined,
        quantity: 4,
        title: 'From $150, includes 4 games per month',
        description: 'All advanced features. Customizable ads (competition, team, event or percentage based).',
        brackets: [
            { upTo: 4, price: 150 },
            { upTo: 10, price: 350 },
            { upTo: 20, price: 640 },
            { upTo: 50, price: 1500 },
            { upTo: 100, price: 2500 }
        ]
    },
    {
        name: 'Premium',
        stripeId: undefined,
        custom: true,
        limit: undefined,
        title: 'Premium features, custom pricing.',
        description: 'All professional features. External API integrations. Custom themes. Dedicated account manager.',
        brackets: undefined
    }
];
exports.annualPlans = [
    {
        name: 'Starter',
        stripeId: 'plan_G8fQrJBC45vC02',
        custom: false,
        limit: 10,
        free: true,
        quantity: 10,
        annual: true,
        title: 'Free, max 10 games per month',
        description: 'Include LIGR and third party advertisements.',
        brackets: [{ upTo: 10, price: 0 }]
    },
    {
        name: 'Advanced',
        stripeId: 'plan_G8fMmtbJ3DESQX',
        custom: false,
        limit: undefined,
        quantity: 4,
        annual: true,
        title: 'From $241, includes 4 games per month',
        description: 'Competition, Team and Player asset management. No ads.',
        brackets: [
            { upTo: 4, price: 241 },
            { upTo: 10, price: 563 },
            { upTo: 20, price: 1045 },
            { upTo: 50, price: 2412 },
            { upTo: 100, price: 4020 }
        ]
    },
    {
        name: 'Professional',
        stripeId: 'plan_G8fRoR7GRNqu6p',
        custom: false,
        limit: undefined,
        quantity: 4,
        annual: true,
        title: 'From $1,026, includes 4 games per month',
        description: 'All advanced features. Customizable ads (competition, team, event or percentage based).',
        brackets: [
            { upTo: 4, price: 1026 },
            { upTo: 10, price: 2814 },
            { upTo: 20, price: 5146 },
            { upTo: 50, price: 12060 },
            { upTo: 100, price: 20100 }
        ]
    },
    {
        name: 'Premium',
        stripeId: undefined,
        custom: true,
        limit: undefined,
        annual: true,
        title: 'Premium features, custom pricing.',
        description: 'All professional features. External API integrations. Custom themes. Dedicated account manager.',
        brackets: undefined
    }
];
exports.allPlans = [...exports.monthlyPlans, ...exports.annualPlans];
exports.freezePlan = 'plan_G8fZgVFpHvIM2r';
exports.TRIAL_DURATION = 14;
exports.isTrial = (date) => {
    const today = moment_1.default();
    const trialEndsAt = moment_1.default(date).add(exports.TRIAL_DURATION, 'days');
    return today.isBefore(trialEndsAt);
};
//# sourceMappingURL=plans.js.map